import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

/*
 * StatusPill: text plus optional icon. Semantic colour is supplementary and is
 * never the sole carrier of meaning, so the label text always states the state.
 */
const statusPillVariants = cva(
  'inline-flex items-center gap-1.5 rounded-lg px-2 py-0.5 text-xs font-medium [&_svg]:size-3.5',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-subtle text-fg-muted',
        success: 'bg-success-surface text-success-text',
        warning: 'bg-warning-surface text-warning-text',
        danger: 'bg-danger-surface text-danger',
        info: 'bg-info-surface text-info-text',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
)

function StatusPill({
  className,
  tone,
  icon,
  children,
}: VariantProps<typeof statusPillVariants> & {
  className?: string
  icon?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <span className={cn(statusPillVariants({ tone }), className)}>
      {icon}
      {children}
    </span>
  )
}

export { StatusPill, statusPillVariants }
